// extracted by mini-css-extract-plugin
module.exports = {"customCta":"CTA_customCta__k8Ay7","secondary":"CTA_secondary__hCi_W"};